import { createSlice } from '@reduxjs/toolkit';
import { getViewInitialState } from 'src/store/view/reducer';
import { confirmClientAction } from '../../../../store/client/actions';
import { initAppAction } from '../../../../store/view/actions';
import type { ViewGiftPageProps } from '../../types';

export interface ViewState {
  isWhitelabel: boolean;
  isMobile: boolean;
  isTyping: boolean;
  isClientConfirmed: boolean;
  is3dsShown: boolean;
  isWidgetShown: boolean;
  error: null | { message: string };
  app: null | string;
  platform: null | string;
}

const initialState = {
  isMobile: false,
  isTyping: false,
  isClientConfirmed: false,
  is3dsShown: false,
  isWidgetShown: true,
  error: null,
  platform: null,
  ...getViewInitialState(),

  isWhitelabel: false, // certificates allowed only on main site,
  app: null,
} as ViewState;

const certificateSlice = createSlice({
  name: 'view',
  initialState,
  reducers: {
    stopTyping(state) {
      state.isTyping = true;
    },
    startTyping(state) {
      state.isTyping = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(initAppAction, (state, { payload: { appName, ...rest } }) => {
        const { isMobile, platform } = rest as ViewGiftPageProps;
        return {
          ...state,
          app: appName,
          isMobile,
          platform,
        };
      })
      .addCase(confirmClientAction, (state, action) => {
        state.isClientConfirmed = !!action.payload;
      });
  },
});

export const { stopTyping, startTyping } = certificateSlice.actions;
export const { name } = certificateSlice;
export default certificateSlice.reducer;
